import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './config/socialGalleryAuth';
import reportWebVitals from './reportWebVitals';
import './assets/sass/main.scss'
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { Provider } from "react-redux";
import store from "./redux/index";
let persister = persistStore(store);

ReactDOM.hydrate(
  <React.StrictMode>
    <Provider store={store} >
      <PersistGate loading={null} persistor={persister} >
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);


reportWebVitals();
